export const availableReactions: Record<ID, string> = {
  1: '👍',
  2: '👎',
  3: '🙌',
  4: '🤝',
  5: '😀',
  6: '😦',
  7: '💯',
  8: '❤',
  9: '🎉',
  10: '🔥',
};

export const mapReactionListItemFromApi = (
  apiReaction: ApiReaction
): ReactionListItem => {
  return {
    reaction: {
      id: apiReaction.reaction,
      emoji: availableReactions[apiReaction.reaction] ?? '👍',
    },
    total: apiReaction.total,
  };
};
